import { action } from 'satcheljs';
import SmimeBccForkingMode from '../store/schema/SmimeBccForkingMode';
import SmimeViewState from '../store/schema/SmimeViewState';

// Action called to set the SmimeBccForkingMode to include appropriate recipients
export default action(
    'setSmimeBccForkingMode',
    (smimeViewState: SmimeViewState, smimeBccForkingMode: SmimeBccForkingMode) => ({
        smimeViewState,
        smimeBccForkingMode,
    })
);
